export default "__VITE_ASSET__DAjqs4_F__"